<script>
  import NavbarReusable from './NavbarReusable.svelte';
  import AdminMonthlyFeedbackReview from './AdminMonthlyFeedbackReview.svelte';
</script>

<div class="app-container">
  <NavbarReusable label="Monthly feedback review" backLink="/admin/all" />
  <AdminMonthlyFeedbackReview />
</div>
